import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAdXmxgF6yiNKHV4L75T0OyfCQoRqHB08U",
    authDomain: "retro-games-slovakia.firebaseapp.com",
    projectId: "retro-games-slovakia",
    storageBucket: "retro-games-slovakia.appspot.com",
    messagingSenderId: "167585370564",
    appId: "1:167585370564:web:9f1fee9526483c80cf5491",
    measurementId: "G-XKBN3WJ1D1",
    databaseURL:
        "https://retro-games-slovakia-default-rtdb.europe-west1.firebasedatabase.app/",
};

export const firebase = initializeApp(firebaseConfig);
export const database = getDatabase(firebase);
export const analytics = getAnalytics(firebase);
export const storage = getStorage(firebase);
export const auth = getAuth();
